import {Controller} from '@hotwired/stimulus';
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--diplomas-edit-modal'
    ];

    openEditModal(event) {
        event.preventDefault();
        showPreloader();

        const data = document.getElementById('diplomas-textarea-readonly').textContent;
        this.profileDiplomasEditModalOutlet.openModal(data);

        hidePreloader()
    }
}
